export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./createFamily.vue?vue&type=template&id=40300ba5&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/createFamily.vue?vue&type=template&id=40300ba5&scoped=true
// module id = 2125
// module chunks = 31